const reporter = {
  inform(error, customAttributes = {}) {
    global?.newrelic?.noticeError(error, customAttributes);
    global?.bugsnag?.notify(error, {metadata: customAttributes});
  },
};

export default reporter;
